import axios from 'axios'

export default {
  actions: {
    async fetchMessage(_, data){
      let dataRes = null
      if(data){
        await axios.get('api/messages', {
          params:data
        }).then(res=>{
          dataRes = res.data
        })
      }else{
        await axios.get('api/messages').then(res=>{
          dataRes = res.data
        })
      }

      return dataRes
    },
    async fetchNextPage(_, {path, data}){
      return await axios.get(path, { params: data })
    },

    async updateMessage(_, data){
      try {
        const { status } = await axios.patch(`api/messages/${data.inc}`);
        return status
      } catch (e) {
        console.warn('Failed fetch [store/messages/updateMessage]', e);
        return false
      }
    }
  },

}
